module.exports = __webpack_public_path__ + "img/1.41aab395.svg";